// extracted by mini-css-extract-plugin
export var breadcrumbDisabled = "Breadcrumbs-module--breadcrumbDisabled--98e92";
export var breadcrumbNavLink = "Breadcrumbs-module--breadcrumbNavLink--fb6e4";
export var breadcrumbs = "Breadcrumbs-module--breadcrumbs--42bf9";
export var breadcrumbsContainer = "Breadcrumbs-module--breadcrumbsContainer--ddd51";